export function slugify(string: string) {
  const slug = string
    .normalize('NFD') // Split accented letters into base + diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^a-z0-9\-]/g, '') // Remove non-alphanumeric/hyphen
    .replace(/-+/g, '-') // Collapse multiple hyphens
    .replace(/^-+|-+$/g, ''); // Trim leading/trailing hyphens

  if (!slug?.length) {
    throw new Error(`Unable to slugify '${string}'`);
  }

  return slug;
}
